<mat-toolbar class="nav app-top-nav">
    <div *appDeviceRenderer="deviceTypes.mobile">
        <button mat-icon-button *ngIf="isAuthenticated" (click)="toggleSidenav()">
            <mat-icon>menu</mat-icon>
        </button>
    </div>
    <div *ngIf="logo$ | async as logo" class="header-logo">
        <a [routerLink]="dashboardLink">
            <img
                data-e2e-id="logo-img"
                [src]="logo | safeUrl"
                class="img-absolute-center img-default-logo"
                alt="logo"
            />
        </a>
    </div>

    <ng-container *ngIf="authenticatedData$ | async as authenticatedData">
        <!-- START: SIDE MENU -->
        <mat-sidenav-container
            class="navbar-sidenav-container"
            *appDeviceRenderer="deviceTypes.mobile"
        >
            <mat-sidenav #sidenav fixedInViewport fixedTopGap="55" class="sidenav">
                <mat-nav-list class="sidenav-list">
                    <div class="user-info">
                        <div class="name">
                            <mat-icon mat-list-icon>account_circle</mat-icon>
                            <span mat-line>{{ authenticatedData.user.name }}</span>
                        </div>
                        <div *ngIf="!!authenticatedData.selectedAccount">
                            <button mat-button [cdkMenuTriggerFor]="menu.childMenu">
                                {{ authenticatedData.selectedAccount.name }}
                                <mat-icon>keyboard_arrow_down</mat-icon>
                            </button>
                            <app-header-menu
                                #menu
                                [align]="'left'"
                                [items]="authenticatedData.menu.accountsMenu"
                                [isMobile]="true"
                            ></app-header-menu>
                        </div>
                    </div>
                    <mat-divider></mat-divider>
                    <ng-container *ngTemplateOutlet="searchInput"></ng-container>
                    <mat-divider></mat-divider>
                    <ng-container *ngFor="let item of authenticatedData.menu.side">
                        <a mat-list-item (click)="item.command()">
                            <div class="sidenav-item">
                                <mat-icon mat-list-icon class="material-icons-outlined">
                                    {{ item.iconName }}
                                </mat-icon>
                                <p mat-line>{{ item.displayName }}</p>
                            </div>
                        </a>
                        <mat-divider></mat-divider>
                    </ng-container>
                </mat-nav-list>
            </mat-sidenav>
        </mat-sidenav-container>
        <!-- END: SIDE MENU -->

        <!-- START: TOP MENU -->
        <ng-container *appDeviceRenderer="deviceTypes.desktop">
            <ng-container *ngTemplateOutlet="searchInput"></ng-container>

            <div class="nav-top-right">
                <ul>
                    <li *ngFor="let item of authenticatedData.menu.top.inline">
                        <a
                            class="a-navigation nav-items-txt"
                            (click)="item.command()"
                            [matTooltip]="item.displayName"
                            matTooltipShowDelay="500"
                        >
                            <mat-icon class="material-icons-outlined">{{ item.iconName }}</mat-icon>
                        </a>
                    </li>
                    <li>
                        <ng-container [ngTemplateOutlet]="helpButton"></ng-container>
                    </li>
                </ul>

                <mat-divider [vertical]="true" class="divider"></mat-divider>

                <a
                    class="user-info"
                    [cdkMenuTriggerFor]="menu.childMenu"
                    [cdkMenuPosition]="[
                        {
                            originX: 'end',
                            originY: 'bottom',
                            overlayX: 'end',
                            overlayY: 'top',
                            offsetY: 0,
                            offsetX: 0
                        }
                    ]"
                >
                    <div>
                        <div class="name">{{ authenticatedData.user.name }}</div>
                        <div class="account">{{ authenticatedData.selectedAccount.name }}</div>
                    </div>
                    <mat-icon class="icon">account_circle</mat-icon>
                </a>

                <app-header-menu
                    #menu
                    [items]="authenticatedData.menu.top.userMenu"
                    [align]="'right'"
                    data-e2e-id="main-menu"
                ></app-header-menu>
            </div>
        </ng-container>

        <div class="nav-top-right" *appDeviceRenderer="deviceTypes.mobile">
            <ul>
                <li>
                    <ng-container [ngTemplateOutlet]="helpButton"></ng-container>
                </li>
            </ul>
        </div>
        <!-- END: TOP MENU -->
    </ng-container>
</mat-toolbar>

<ng-template #searchInput>
    <div searchInput>
        <mat-form-field class="input">
            <input
                matInput
                type="text"
                placeholder="Search"
                (keyup.enter)="search($event.target.value)"
            />
            <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>
    </div>
</ng-template>

<ng-template #helpButton>
    <a class="icon-button" appHelpArticle>
        <mat-icon class="material-icons-outlined icon">help_outline</mat-icon>
    </a>
</ng-template>
